export default __webpack_public_path__ + "static/media/arrows-move.25f15427.svg";